(function (app) {
    app.constant("migratorId", "0548a344-57d7-48b6-92b1-19a0480c9edf");
})(window.app); //jshint ignore:line